export const API_URL = 'https://my-self-storage.herokuapp.com/API/'

export const ping = API_URL
export const contactMailUrl = API_URL + 'contact/'
export const reserveMailUrl = API_URL + 'book/'
export const box = API_URL + 'BoxPricings/?format=json'

export const repcaptchaSiteKey = '6LfhE4kUAAAAADSiOOMxI4Hi0anG-1KLpSN3Txrg'